
export const SellerShopCompanyQuery = new TypedDocumentString(`
    query SellerShopCompanyQuery($handle: String!) {
  publicSeller(handle: $handle) {
    doc {
      ...SellerItem
      invoiceDetails {
        companyName {
          value
          __typename
        }
        SWIFT
        companyCode
        companyVAT
        comanyAddress {
          value
          __typename
        }
        invoiceBank {
          value
          __typename
        }
        invoiceBankAccount
        invoiceBankCode
        __typename
      }
      __typename
    }
    __typename
  }
}
    fragment DocumentColorHsla on DocumentColorHsla {
  h
  s
  l
  a
  __typename
}
fragment ImageNodeItem on ImageNodeItem {
  _id
  alt
  uploadDate
  type
  url
  fallbackUrl
  img
  height
  width
  noProxy
  hsla {
    ...DocumentColorHsla
    __typename
  }
  aspect {
    x
    y
    __typename
  }
  audio
  videoHls
  video
  isVideo
  __typename
}
fragment Image on Image {
  alt {
    value
    __typename
  }
  isVideo
  image2 {
    ...ImageNodeItem
    __typename
  }
  __typename
}
fragment SellerItem on SellerDoc {
  _id
  name
  handle
  logo {
    ...Image
    __typename
  }
  __typename
}`, {"hash":"0d480a18c89b6d11ece658d70c14e220d8083b3f7e6391330707850e44e5ca80"});